const labels = {
    'podcasts.apple.com': 'Apple Podcasts',
    'spotify.com': 'Spotify',
    'youtube.com': 'YouTube',
    'youtu.be': 'YouTube',
    'soundcloud.com': 'SoundCloud',
    'music.amazon.com': 'Amazon Music',
    'feeds.acast.com': 'RSS',
    'telequebec.tv': 'Télé-Québec',
    'crave.ca': 'Crave',
};

const icons = {
    'podcasts.apple.com': 'fa-itunes-note',
    'spotify.com': 'fa-spotify',
    'youtube.com': 'fa-youtube',
    'youtu.be': 'fa-youtube',
    'soundcloud.com': 'fa-soundcloud',
    'amazon.com': 'fa-amazon',
    'feeds.acast.com': 'rss_feed',
};

export function getServiceIconFromUrl(url: string | null) {
    if (url === null) {
        return null;
    }
    const domain = url.replace(/^https?:\/\/([^/]+)\/?.*$/, '$1');
    const baseDomain = domain.split('.').slice(-2).join('.');
    return [domain, baseDomain].reduce((name, key) => name || icons[key] || null, null);
}

function getServiceNameFromUrl(url: string | null): string | null {
    if (url === null) {
        return null;
    }
    const domain = url.replace(/^https?:\/\/([^/]+)\/?.*$/, '$1');
    const baseDomain = domain.split('.').slice(-2).join('.');
    return (
        [domain, baseDomain].reduce((name, key) => name || labels[key] || null, null) || baseDomain
    );
}

export default getServiceNameFromUrl;
